import { logDebug } from "@/lib/log";
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
// THIS BREAKS THE AUTH. The redirect always derives from window.location.origin.

const NEXT_KEY = "lettric:auth-next";
export const DEFAULT_AUTH_DEST = "/admin";

// Remember where the user was headed before we bounce them through Google —
// react-router location.state doesn't survive a full-page OAuth round trip.
export function startGoogleSignIn(next) {
  try {
    if (next && next.startsWith("/")) sessionStorage.setItem(NEXT_KEY, next);
    else sessionStorage.removeItem(NEXT_KEY);
  } catch (err) {
    logDebug("could not persist auth destination", err);
  }
  const redirect = `${window.location.origin}/app/auth/callback`;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
}

export function consumeGoogleNext() {
  try {
    const next = sessionStorage.getItem(NEXT_KEY);
    sessionStorage.removeItem(NEXT_KEY);
    if (next && next.startsWith("/")) return next;
  } catch (err) {
    logDebug("could not read auth destination", err);
  }
  return DEFAULT_AUTH_DEST;
}
